import { render, staticRenderFns } from "./editJournal.vue?vue&type=template&id=2feab2a8&scoped=true&"
import script from "./editJournal.vue?vue&type=script&lang=js&"
export * from "./editJournal.vue?vue&type=script&lang=js&"
import style0 from "./editJournal.vue?vue&type=style&index=0&id=2feab2a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feab2a8",
  null
  
)

export default component.exports